import { Controller, useFormContext } from 'react-hook-form';
import { Modal, ToggleValueInput, useLocale } from 'shared-ui';

import { AppMessages } from 'i18n/messages';
import { PasswordValidationInfo } from 'ui/passwordValidationInfo/PasswordValidationInfo';

import * as Styled from './UpdatePassword.styles';
import { UpdatePasswordProps, UpdatePasswordForm } from './UpdatePassword.types';

export const UpdatePassword = ({
  onSubmit,
  isModalOpen,
  isLoading,
  passwordPolicy,
  onClose,
  modalBackdropNotTransparent,
}: UpdatePasswordProps) => {
  const { formatMessage } = useLocale();

  const {
    handleSubmit,
    control,
    formState: { errors, isValid, isDirty },
    getFieldState,
  } = useFormContext<UpdatePasswordForm>();

  const newPassword = getFieldState('newPassword');
  const repeatPassword = getFieldState('repeatPassword');
  const isError = newPassword.invalid || repeatPassword.invalid;

  return (
    <Modal
      header={formatMessage({ id: AppMessages['profile.changePassword.title'] })}
      open={isModalOpen}
      size="medium"
      type="form"
      onSubmit={handleSubmit(onSubmit)}
      submitButtonDisabled={isLoading || !isValid}
      submitButtonText={formatMessage({ id: AppMessages['common.save'] })}
      onClose={onClose}
      modalBackdropNotTransparent={modalBackdropNotTransparent}
    >
      {!onClose && <Styled.Text>{formatMessage({ id: AppMessages['updatePassword.description'] })}</Styled.Text>}
      <Styled.Wrapper>
        <Controller
          name="newPassword"
          defaultValue=""
          control={control}
          render={({ field }) => (
            <ToggleValueInput
              {...field}
              errorMessage={errors.newPassword?.message}
              type="password"
              label={formatMessage({ id: AppMessages['profile.changePassword.password.label'] })}
              placeholder={formatMessage({
                id: AppMessages['profile.changePassword.password.placeholder'],
              })}
              required
            />
          )}
        />

        <Controller
          name="repeatPassword"
          defaultValue=""
          control={control}
          render={({ field }) => (
            <ToggleValueInput
              {...field}
              errorMessage={errors.repeatPassword?.message}
              type="password"
              label={formatMessage({ id: AppMessages['profile.changePassword.confirmPassword.label'] })}
              placeholder={formatMessage({
                id: AppMessages['profile.changePassword.confirmPassword.placeholder'],
              })}
              required
            />
          )}
        />

        <PasswordValidationInfo
          isError={isError}
          isVisible={isDirty}
          minimumPasswordLength={passwordPolicy?.minimumPasswordLength}
        />
      </Styled.Wrapper>
    </Modal>
  );
};
